<template>
  <div
    ref="cont"
    class="ptabl_container"
    :data-tst="`${tstPrefix}_ptabl`"
  >
    <div
      class="poker-table-skeleton ptabl"
      :class="`ptabl_${l_tableDirection}`"
    >
      <slot name="any" />
      <div class="ptabl_table">
        <div class="ptabl_center">
          <slot name="center" />
        </div>
        <div
          class="ptabl_seats"
          :class="`${l_tableDirection}-seats`"
        >
          <slot name="seats_before" />
          <div
            v-for="(player, idx) in players"
            :key="player.position + idx"
            :class="[playersPlacement[idx]]"
            :data-tst="`${tstPrefix}_seat_${player.position}`"
            class="ptabl_seats_seat"
          >
            <slot :name="player.position"></slot>
            <!-- :name="`${skeleton ? 'skeleton_' : ''}${player.position}`" -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'PokerTableSkeleton',
  props: {
    players: { default: () => [] },
    rotateHero: Boolean,
    heroPosition: { default: () => '' },
    tableDirection: String,
    tstPrefix: { default: () => 'ptabl' },
    // skeleton: Boolean,
  },
  data() {
    return {
      l_tableDirection: 'horizontal',
    }
  },
  mounted() {
    nextTick(() => {
      this.setTableDirection()
    })
  },
  methods: {
    setTableDisplayMode(e) {
      if (this.tableDirection) {
        this.l_tableDirection = this.tableDirection
        return
      }
      // console.log(e, 'setTableDisplayMode')
      this.setTableDirection()
      setTimeout(() => {
        this.setTableDirection()
      }, 99)
      setTimeout(() => {
        this.setTableDirection()
      }, 333)
      setTimeout(() => {
        this.setTableDirection()
      }, 1666)
    },
    setTableDirection() {
      if (this.tableDirection) {
        this.l_tableDirection = this.tableDirection
        return
      }
      let vertical = this.$store.getters.globals_mobile && this.wSize.width < this.wSize.height
      const { cont } = this.$refs
      if (cont && !vertical) {
        const width = cont.offsetWidth
        const height = cont.offsetHeight
        const ratio = width / height
        // console.log(ratio)
        if (ratio < 1) {
          vertical = true
        }
        // debuggeronst ratio = width / height
      }
      this.l_tableDirection = vertical ? 'vertical' : 'horizontal'
      // console.log(this.l_tableDirection)
    },
    getSeatsFromHero({ seats, heroSeatIdx }) {
      const playerIdx = this.players.findIndex(p => p.position === this.l_heroPosition)
      // const playerIdx = this.players.findIndex(p => p.position === this.hero?.position)
      const playerSeat = seats[playerIdx]
      const playerSeatIdx = seats.findIndex(p => p === playerSeat)

      // const heroSeatIdx = seats.findIndex(p => p === heroSeat)
      // debugger
      const diff = playerSeatIdx - heroSeatIdx

      if (diff === 0) {
        return seats
      }

      let res = []
      const l = seats.length
      const doubledSeats = [...seats, ...seats]

      if (diff > 0) {
        const moveIdx = l - diff
        res = doubledSeats.filter((_, idx) => idx >= moveIdx)
      }
      if (diff < 0) {
        res = doubledSeats.filter((_, idx) => idx >= Math.abs(diff))
      }
      // res = res.slice(0, l)
      return res
    },
  },
  computed: {
    l_heroPosition() {
      if (this.heroPosition) {
        return this.heroPosition
      }
      // const res = this.players.find(p => p.is_active)
      let res = this.players.find(p => p.is_hero)
      res = res?.position
      return res
      // return { position: 'BTN' }
    },
    l_rotateHero() {
      if (this.rotateHero !== null) {
        return this.rotateHero
      }
      return false
    },
    // rotation() {
    //   return this.l_heroPosition ? this.l_tableDirection === 'vertical' ? 'hero_vr' : 'hero' : 'default'
    // },
    playersPlacement() {
      const placement = this.placements[`_${this.players.length}`]
      const plKey = this.l_tableDirection === 'vertical' ? 'seats_vr' : 'seats'
      const idxKey = this.l_tableDirection === 'vertical' ? 'seat_hero_vr_idx' : 'seat_hero_idx'
      const seats = placement[plKey]
      const heroSeatIdx = placement[idxKey]
      // debugger
      // const res = this.l_rotateHero ? seats : seats
      const res = this.l_rotateHero ? this.getSeatsFromHero({ seats, heroSeatIdx }) : seats
      return res
    },
    placements() {
      const res = {
        _2: {
          seat_hero_idx: 1,
          seats: [
            'top-center', // SB
            'bottom-center',
          ],
          seat_hero_vr_idx: 1,
          seats_vr: [
            'top-center', // SB
            'bottom-center',
          ],
        },
        _3: {
          seat_hero_idx: 1,
          seats: [
            'top-right', // BTN
            'bottom-center',
            'top-left',
          ],
          seat_hero_vr_idx: 1,
          seats_vr: [
            'right-middle-top', // BTN
            'bottom-center',
            'left-middle-top',
          ],
        },
        _4: {
          seat_hero_idx: 2,
          seats: [
            'top-left',
            'top-right', // BTN
            'bottom-right',
            'bottom-left',
          ],
          seat_hero_vr_idx: 2,
          seats_vr: [
            'top-center',
            'right-center', // BTN
            'bottom-center',
            'left-center',
          ],
        },
        _5: {
          seat_hero_idx: 4,
          seats: [
            'left-center',
            'top-left',
            'top-right', // BTN
            'right-center',
            'bottom-center',
          ],
          seat_hero_vr_idx: 4,
          seats_vr: [
            'left-middle-bottom',
            'left-middle-top',
            'right-middle-top',
            'right-middle-bottom', // BTN
            'bottom-center',
          ],
        },
        _6: {
          seat_hero_idx: 5,
          seats: [
            'bottom-left',
            'left-center',
            'top-left',
            'top-right', // BTN
            'right-center',
            'bottom-right',
          ],
          seat_hero_vr_idx: 5,
          seats_vr: [
            'left-middle-bottom',
            'left-middle-top',
            'top-center',
            'right-middle-top',
            'right-middle-bottom', // BTN
            'bottom-center',
          ],
          // seat_hero_hr: 'bottom-center',
        },
        _7: {
          seat_hero_idx: 6,
          seats: [
            'bottom-left',
            'left-center',
            'top-left-end',
            'top-center',
            'top-right-end', // BTN
            'right-center',
            'bottom-right',
          ],
          seat_hero_vr_idx: 0,
          seats_vr: [
            'bottom-center',
            'left-bottom-end',
            'left-top-end',
            'left-top-start',
            'right-top-start', // BTN
            'right-top-end',
            'right-bottom-end',
          ],
        },
        _8: {
          seat_hero_idx: 0,
          seats: [
            'bottom-center',
            'bottom-left-end',
            'left-center',
            'top-left-end',
            'top-center',
            'top-right-end', // BTN
            'right-center',
            'bottom-right-end',
          ],
          seat_hero_vr_idx: 0,
          seats_vr: [
            'bottom-center',
            'left-bottom-end',
            'left-top-end',
            'left-top-start',
            'top-center',
            'right-top-start', // BTN
            'right-top-end',
            'right-bottom-end',
          ],
        },
        _9: {
          seat_hero_idx: 0,
          seats: [
            'bottom-center-nudge-right',
            'bottom-left-end-middle',
            'left-middle-bottom-middle',
            'left-middle-top-middle',
            'top-left-end-middle',
            'top-center-nudge-right',
            'top-right-end', // BTN
            'right-center',
            'bottom-right-end',
          ],
          seat_hero_vr_idx: 0,
          seats_vr: [
            'bottom-center',
            'left-bottom-end',
            'left-top-end-middle',
            'left-top-start-middle',
            'left-top-start',
            'top-center',
            'right-top-start', // BTN
            'right-top-end',
            'right-bottom-end',
          ],
        },
        _10: {
          seat_hero_idx: 0,
          seats: [
            'bottom-center-nudge-right',
            'bottom-left-end-middle',
            'left-middle-bottom-middle',
            'left-middle-top-middle',
            'top-left-end-middle',
            'top-center-nudge-right',
            'top-right-end', // BTN
            'right-middle-bottom-middle',
            'right-middle-top-middle',
            'bottom-right-end',
          ],
          seat_hero_vr_idx: 0,
          seats_vr: [
            'bottom-center',
            'left-bottom-end',
            'left-top-end-middle',
            'left-top-start-middle',
            'left-top-start',
            'top-center',
            'right-top-start', // BTN
            'right-top-start-middle',
            'right-top-end-middle',
            'right-bottom-end',
          ],
        },
      }
      if (this.l_rotateHero) {
        Object.keys(res).forEach(key => {
          const settingsVal = this.$store.getters.heroTableSeats[key]
          res[key].seat_hero_idx = settingsVal[0]
          res[key].seat_hero_vr_idx = settingsVal[1]
        })
      }
      return res
    },
    wSize() {
      return this.$store.getters.globals_window_size
    },
    el_resize() {
      return this.$store.getters.el_resize
    },
  },
  watch: {
    // TODO use resize observer instead (IE, polyfis omg, testing)
    wSize: {
      immediate: false,
      handler: 'setTableDisplayMode',
    },
    el_resize: {
      immediate: false,
      handler: 'setTableDisplayMode',
    },
  },
}
</script>
<style lang="scss" scoped>
// https://css-tricks.com/understanding-flex-grow-flex-shrink-and-flex-basis/
.ptabl {
  &_container {
    display: flex;
    // align-items: center;
    // justify-content: center;
    flex: 1;
    flex-shrink: 0;
    width: 100%;

    // position: relative;
    // align-items: center;
    // justify-content: center;
    // --table-hor-height: 100%;
    // --table-hor-width: 100%;
    --clr-table-back: transparent;
    --clr-table-outline: var(--clr-black-1-2);
    --clr-seat-back: var(--clr-black-2);
    // --clr-seat-back: var(--clr-black-1);
    // --clr-seat-back: var(--clr-table-outline);

    --z-index-center: 2;
    --z-index-seats: 1;

    --table-hor-min-height: unset;
    --table-hor-max-height: 24em;
    --table-hor-min-width: unset;
    --table-hor-max-width: unset;

    // --table-ver-height: 100%;
    // --table-ver-width: 100%;
    --table-ver-min-height: unset;
    --table-ver-max-height: unset;
    --table-ver-min-width: unset;
    --table-ver-max-width: 32em;

    // --player-circle-size: clamp(3.25rem, 4.25em, 4.25rem);
    --player-circle-size: clamp(2.5rem, 4.25em, 4.25rem);
    --player-name-size: clamp(0.65rem, 1em, 1rem);

    --table-radius: 99px;
    --table-radius: 999px;
    // --border-width-base: 1em;
    // --border-width-base: 0.75em;
    // --border-width-base: 0.425em;
    // --border-width-base: 0.375em;
    // --border-width-base: 0.325em;
    // --border-width-base: 1px;
    // --border-width-base: 0px;
    --player-border-width: clamp(2px, 0.225em, 6px);
    --border-width-base: 0.5em;
    --border-width-base: var(--player-border-width);
    --table-border-width: clamp(1px, var(--border-width-base), 12px);
    --margin-horizontal: auto;

    // --table-border-width: 3px;

    --cards-space: 5.5em;
  }
  // position: absolute;
  display: flex;
  flex: 1;

  // --cards-space: 2.75em;

  padding: var(--padding);
  &_horizontal {
    margin: var(--margin-horizontal);
    min-height: var(--table-hor-min-height);
    max-height: var(--table-hor-max-height);
    min-width: var(--table-hor-min-width);
    max-width: var(--table-hor-max-width);
    --padding: calc(var(--player-circle-size) / 2)
      calc((var(--player-circle-size) / 2) + var(--cards-space));
    .ptabl_table {
      &:before {
        width: calc(100% + var(--table-border-width) * 1.25);
      }
    }
  }
  &_vertical {
    margin: 0 auto;
    min-width: var(--table-ver-min-width);
    max-width: var(--table-ver-max-width);
    min-height: var(--table-ver-min-height);
    max-height: var(--table-ver-max-height);
    --padding: calc(var(--player-circle-size) / 2) calc(var(--player-circle-size) / 1.5);

    // .ptabl_table {
    //   &:before {
    //     height: calc(100% + var(--table-border-width) + 1em);
    //     top: calc(-0.5 * var(--table-border-width) - 1em);
    //     transform: perspective(100em) rotateX(12deg);
    //   }
    // }
  }

  &_table {
    position: relative;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    transition: 0.15s;
    &:before {
      content: '';
      position: absolute;
      left: calc(-0.5 * var(--table-border-width));
      width: calc(100% + var(--table-border-width));
      height: calc(100% + var(--table-border-width));
      top: calc(-0.5 * var(--table-border-width));
      background: var(--clr-table-back);
      transition: 0.15s;
      border-radius: var(--table-radius);
      border: solid var(--table-border-width) var(--clr-table-outline);

      background: var(--clr-table-back);
      transition: 0.15s;
      border-radius: var(--table-radius);
      border: solid var(--table-border-width) var(--clr-table-outline);

      // height: calc(100% + var(--table-border-width) + 1em);
      // top: calc(-0.5 * var(--table-border-width) - 1em);
      // transform: perspective(100em) rotateX(32deg);
      // background: rgba(255, 255, 255, 0.115);
    }

    // box-shadow: 0px 0px 2px 1px var(--clr-black-0);
    // box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.28);
    // box-shadow: 0px 4px 8px 1px red;
    // box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
  &_center {
    z-index: var(--z-index-center);
  }
  &_seats {
    position: absolute;
    z-index: var(--z-index-seats);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &_seat {
      position: absolute;
      border-radius: 50%;
      height: var(--player-circle-size);
      width: var(--player-circle-size);
      background: var(--clr-seat-back);
      display: flex;
      align-items: center;
      justify-content: center;

      // debug
      // &:after {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   left: 50%;
      //   width: 1px;
      //   height: 100%;
      //   background: red;
      //   transform: translate(-50%, 0);
      // }
      // &:before {
      //   content: '';
      //   position: absolute;
      //   top: 50%;
      //   left: 0;
      //   width: 100%;
      //   height: 1px;
      //   background: red;
      //   transform: translate(0, -50%);
      // }
    }
  }
}
</style>
<style lang="scss">
.card-anim-x-left {
  --card-enter-x: 32px;
  --card-leave-x: 32px;
}
.card-anim-x-right {
  --card-enter-x: -32px;
  --card-leave-x: -32px;
}
.card-anim-y-top {
  --card-enter-y: -32px;
  --card-leave-y: -32px;
}
.card-anim-y-bottom {
  --card-enter-y: 32px;
  --card-leave-y: 32px;
}

.bet-column {
  .player_bet {
    --bet-gap: 0.125em;
    --bet-direction: column;
  }
}

.bet-anim-y-bottom {
  .player_bet {
    --bet-leave-y: 32px;
    --bet-leave-x: 0;
  }
}
.bet-anim-y-bottom-left {
  .player_bet {
    --bet-leave-y: 32px;
    --bet-leave-x: -32px;
  }
}
.bet-anim-y-bottom-right {
  .player_bet {
    --bet-leave-y: 32px;
    --bet-leave-x: 32px;
  }
}
.bet-anim-y-top {
  .player_bet {
    --bet-leave-y: -32px;
    --bet-leave-x: 0;
  }
}
.bet-anim-y-top-left {
  .player_bet {
    --bet-leave-y: -32px;
    --bet-leave-x: -32px;
  }
}
.bet-anim-y-top-right {
  .player_bet {
    --bet-leave-y: -32px;
    --bet-leave-x: 32px;
  }
}

.bet-anim-x-left {
  .player_bet {
    --bet-leave-y: 0;
    --bet-leave-x: -32px;
  }
}
.bet-anim-x-left-top {
  .player_bet {
    --bet-leave-y: 32px;
    --bet-leave-x: -32px;
  }
}
.bet-anim-x-left-bottom {
  .player_bet {
    --bet-leave-y: -32px;
    --bet-leave-x: -32px;
  }
}
.bet-anim-x-right {
  --bet-inset-invisible: 0;
  --bet-inset-visible: 90% 0;
  // .player_bet {
  //   --bet-leave-y: 0;
  //   --bet-leave-x: 32px;
  // }
}
.bet-anim-x-right-top {
  .player_bet {
    --bet-leave-y: -32px;
    --bet-leave-x: 32px;
  }
}
.bet-anim-x-right-bottom {
  .player_bet {
    --bet-leave-y: 32px;
    --bet-leave-x: 32px;
  }
}

.dealer-chip-top-left {
  .player_dealer-chip {
    left: -1.75em;
    bottom: 2.5em;
  }
}
.dealer-chip-bottom-left {
  .player_dealer-chip {
    left: -1.75em;
    top: 2.5em;
  }
}
.dealer-chip-bottom-bottom-left {
  .player_dealer-chip {
    left: -0.75em;
    top: 4.25em;
  }
}
.dealer-chip-top-right {
  .player_dealer-chip {
    right: -1.75em;
    bottom: 2.5em;
  }
}
.dealer-chip-top-top-left {
  .player_dealer-chip {
    left: -0.25em;
    bottom: 4.25em;
  }
}
.dealer-chip-top-top-right {
  .player_dealer-chip {
    right: -0.25em;
    bottom: 4.25em;
  }
}
.dealer-chip-bottom-right {
  .player_dealer-chip {
    right: -1.75em;
    top: 2.5em;
  }
}
.dealer-chip-bottom-bottom-right {
  .player_dealer-chip {
    right: -0.75em;
    top: 4.25em;
  }
}
.bet-top {
  .player_bet_inner {
    margin: -1em auto auto auto;
  }
  .card-row_container {
    @extend .card-anim-y-top;
  }
}
.bet-bottom {
  .player_bet_inner {
    margin: auto auto -1em auto;
  }
  .card-row_container {
    @extend .card-anim-y-bottom;
  }
}
.bet-top-right {
  .player_bet {
    margin-right: 8em;
    top: 0em;
  }
}
.bet-bottom-right {
  .player_bet_inner {
    margin: auto 0 0 auto;
    .player_bet_coin_cont {
      right: calc(-100% + 1em);
    }
    .player_bet_money {
      right: calc(-100% + 1em);
    }
  }
}
.bet-bottom-left {
  .player_bet_inner {
    margin: auto auto 0 0;
    .player_bet_coin_cont {
      order: 3;
      left: calc(-100% + 1em);
    }
    .player_bet_money {
      left: calc(-100% + 1em);
    }
  }
}
.bet-hero {
  .player_bet_inner {
    margin: 0.5em 0 auto auto;
    .player_bet_coin_cont {
      left: calc(100% - 1em);
    }
    .player_bet_money {
      left: calc(100% - 1em);
    }
  }
}

.coin-right {
  .player_bet_coin_cont {
    right: -1.4em;
  }
}
.coin-left {
  .player_bet_coin_cont {
    left: -1.4em;
  }
}
.coin-bottom {
  .player_bet_coin_cont {
    bottom: -1em;
  }
}

.bounty-top {
  .player_bounty {
    // --bounty-inset: auto auto 100% auto;
    // --bounty-transform: translate(0, 50%);
  }
}
// .bounty-bottom-right {
//   .player_bounty {
//     left: -100%;
//     top: 100%;
//   }
// }

.player_content-hover {
  transition: 0.22s;
  opacity: 0;
}
.player_content_before {
  position: absolute;
  display: flex;
  align-items: center;
  --right-x: 0px;
  --left-x: unset;
  &_back {
    --content-before-radius: 99px;
    --clr-content-before-back: var(--clr-black-1);
    height: 100%;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      background: var(--clr-content-before-back);
      border-radius: var(--content-before-radius);
      height: 100%;
      width: calc(145% + 0.5em);
    }
  }
}

.cards-left {
  .player_cards {
    right: calc(100% + 0.7em);
    .card-row_container {
      @extend .card-anim-x-left;
    }
    .card-row_shrinked {
      .card-row_card:nth-child(1) {
        z-index: 3;
        transform: translate(1em, 0);
        box-shadow: 1px 0px 2px var(--clr-black-0);
      }
    }
  }
  .player_content_before {
    --right-x: unset;
    --left-x: 0px;
    right: calc(100% - 0.5em);
    &::before {
      right: -45%;
    }
  }
  &:hover {
    .player_content-hover {
      opacity: 1;
    }
  }
}
.cards-right {
  .player_cards {
    left: calc(100% + 0.7em);
    .card-row_container {
      @extend .card-anim-x-right;
    }
    .card-row_shrinked {
      .card-row_card:nth-child(2) {
        z-index: 3;
        transform: translate(-1em, 0);
        box-shadow: -1px 0px 2px var(--clr-black-0);
      }
    }
  }
  .player_content_before {
    left: calc(100% - 0.5em);
    &::before {
      left: -45%;
    }
  }
  &:hover {
    .player_content-hover {
      opacity: 1;
    }
  }
}
.cards-top {
  .player_cards {
    bottom: calc(100% + 0.5em);
  }
}
.cards-bottom {
  .player_cards {
    top: calc(100% + 0.5em);
  }
}

.bet-hero-on-top-of-cards {
  .player_bet_inner {
    display: flex;
    align-items: center;
    position: absolute;
    top: -5.6em;
    justify-content: center;
    width: 100%;
    .player_bet_coin_cont {
      position: static !important;
    }
    .player_bet_money {
      position: static !important;
    }
  }
}
.bet-hero-on-bottom-of-cards {
  .player_bet_inner {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -4.75em;
    justify-content: center;
    width: 100%;
    .player_bet_coin_cont {
      position: static !important;
    }
    .player_bet_money {
      position: static !important;
    }
  }
}

.horizontal-seats {
  .top-center {
    @extend .cards-right;
    @extend .dealer-chip-bottom-left;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% 0;
  }
  .top-center-nudge-right {
    @extend .cards-right;
    @extend .dealer-chip-bottom-left;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% 0;
  }
  .top-right {
    @extend .cards-right;
    @extend .dealer-chip-bottom-left;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% -150%;
  }
  .top-right-end {
    @extend .cards-right;
    @extend .dealer-chip-bottom-left;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% -250%;
  }
  .top-left {
    @extend .cards-left;
    @extend .dealer-chip-bottom-right;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% 150%;
  }
  .top-left-end {
    @extend .cards-left;
    @extend .dealer-chip-bottom-right;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% 250%;
  }
  .top-left-end-middle {
    @extend .cards-left;
    @extend .dealer-chip-bottom-right;
    @extend .bounty-top;

    --bet-inset-visible: 90% 0;
    --bet-inset-pot: 200% 250%;
  }
  .bottom-center {
    @extend .cards-right;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% 0;
  }
  .bottom-center-nudge-right {
    @extend .cards-right;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% 0;
  }
  .bottom-right {
    @extend .cards-right;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% -150%;
  }
  .bottom-right-end {
    @extend .cards-right;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% -250%;
  }
  .bottom-left {
    @extend .cards-left;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% 150%;
  }
  .bottom-left-end {
    @extend .cards-left;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% 250%;
  }
  .bottom-left-end-middle {
    @extend .cards-left;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: -90% 0;
    --bet-inset-pot: -200% 250%;
  }
  .right-center {
    @extend .cards-right;
    @extend .dealer-chip-bottom-bottom-left;
    @extend .bet-column;

    --bet-inset-visible: 0 -115%;
    --bet-inset-pot: 0 -400%;
  }
  .right-middle-top-middle {
    @extend .cards-right;
    @extend .dealer-chip-bottom-bottom-left;
    @extend .bet-column;

    --bet-inset-visible: 0 -115%;
    --bet-inset-pot: 90% 400%;
  }
  .right-middle-bottom-middle {
    @extend .cards-right;
    @extend .dealer-chip-top-top-left;
    @extend .bet-column;

    --bet-direction: row-reverse;
    --bet-inset-visible: 0 -115%;
    --bet-inset-pot: -90% 400%;
  }
  .left-center {
    @extend .dealer-chip-bottom-bottom-right;
    @extend .cards-left;
    @extend .bet-column;

    --bet-inset-visible: 0 115%;
    --bet-inset-pot: 0 400%;
  }
  .left-middle-top-middle {
    @extend .cards-left;
    @extend .dealer-chip-bottom-bottom-right;
    @extend .bet-column;

    --bet-inset-visible: 0 115%;
    --bet-inset-pot: 90% 400%;
  }
  .left-middle-bottom-middle {
    @extend .cards-left;
    @extend .dealer-chip-top-top-right;
    @extend .bet-column;

    --bet-inset-visible: 0 115%;
    --bet-inset-pot: -90% 400%;
  }
}

.vertical-seats {
  @extend .bounty-top;
  @extend .bet-column;
  .card-row_cards {
    align-items: flex-end;
    height: 0;
  }

  .top-center {
    @extend .cards-bottom;
    .card-row_cards {
      align-items: flex-start;
    }
    @extend .dealer-chip-bottom-left;
    --bet-inset-visible: 200% 0;
    --bet-inset-pot: 500% 0;
    .player_cards_empty {
      --bet-inset-visible: 160% 0;
    }
  }
  .bottom-center {
    @extend .cards-top;
    @extend .dealer-chip-top-right;
    --bet-inset-visible: -200% 0;
    --bet-inset-pot: -500% 0;
    .player_cards_empty {
      --bet-inset-visible: -160% 0;
    }
  }
  .left-center {
    @extend .cards-top;
    @extend .dealer-chip-top-right;
    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: 10% 325%;
  }
  .left-top-start {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: 325% 275%;
  }
  .left-top-end {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: 10% 325%;
  }
  .left-middle-top {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: 200% 325%;
  }
  .left-middle-bottom {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: -200% 325%;
  }
  .left-bottom-end {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: -325% 275%;
  }
  .right-center {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: 10% -325%;
    --bet-direction: row-reverse;
  }
  .right-top-start {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: 325% -275%;
    --bet-direction: row-reverse;
  }
  .right-top-end {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: -10% -325%;
    --bet-direction: row-reverse;
  }
  .right-middle-top {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: 200% -325%;
    --bet-direction: row-reverse;
  }
  .right-middle-bottom {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: -200% -325%;
    --bet-direction: row-reverse;
  }
  .right-bottom-end {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: -325% -275%;
    --bet-direction: row-reverse;
  }
  .left-bottom-end-middle {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 35% 95%;
    --bet-inset-pot: -400% 200%;
  }
  .left-top-end-middle {
    @extend .cards-top;
    @extend .dealer-chip-top-right;

    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: -150% 325%;
  }
  .left-top-start-middle {
    @extend .cards-top;
    @extend .dealer-chip-top-right;
    --bet-inset-visible: 60% 90%;
    --bet-inset-pot: 100% 325%;
  }
  .right-top-end-middle {
    @extend .cards-top;
    @extend .dealer-chip-top-left;

    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: -150% 325%;
  }
  .right-top-start-middle {
    @extend .cards-top;
    @extend .dealer-chip-top-left;
    --bet-inset-visible: 60% -90%;
    --bet-inset-pot: 100% 325%;
  }
}

.top-center {
  top: calc(-1 * (var(--player-circle-size) / 2));
}
.bottom-center {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
}
.left-center {
  left: calc(-1 * (var(--player-circle-size) / 2));
}
.right-center {
  right: calc(-1 * (var(--player-circle-size) / 2));
}

.top-right {
  top: calc(-1 * (var(--player-circle-size) / 2));
  right: calc(30% - var(--player-circle-size) / 2);
}
.bottom-right {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
  right: calc(30% - var(--player-circle-size) / 2);
}

.top-left {
  top: calc(-1 * (var(--player-circle-size) / 2));
  left: calc(30% - var(--player-circle-size) / 2);
}
.bottom-left {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
  left: calc(30% - var(--player-circle-size) / 2);
}

.top-right-end {
  top: calc(-1 * (var(--player-circle-size) / 2));
  right: calc(18% - var(--player-circle-size) / 2);
}
.bottom-right-end {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
  right: calc(18% - var(--player-circle-size) / 2);
}

.top-left-end {
  top: calc(-1 * (var(--player-circle-size) / 2));
  left: calc(18% - var(--player-circle-size) / 2);
}
.bottom-left-end {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
  left: calc(18% - var(--player-circle-size) / 2);
}

// ----desktop 9players
.top-center-nudge-right {
  top: calc(-1 * (var(--player-circle-size) / 2));
  right: calc(46.5% - var(--player-circle-size) / 2);
}
.bottom-center-nudge-right {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
  right: calc(46.5% - var(--player-circle-size) / 2);
}
.top-left-end-middle {
  top: calc(-1 * (var(--player-circle-size) / 2));
  left: calc(25% - var(--player-circle-size) / 2);
}
.bottom-left-end-middle {
  bottom: calc(-1 * (var(--player-circle-size) / 2));
  left: calc(25% - var(--player-circle-size) / 2);
}
.left-middle-top-middle {
  top: calc(25% - var(--player-circle-size) / 2);
  left: calc(-1 * (var(--player-circle-size) / 5));
}
.left-middle-bottom-middle {
  bottom: calc(25% - var(--player-circle-size) / 2);
  left: calc(-1 * (var(--player-circle-size) / 5));
}
.right-middle-top-middle {
  top: calc(25% - var(--player-circle-size) / 2);
  right: calc(-1.2 * (var(--player-circle-size) / 2));
}
.right-middle-bottom-middle {
  bottom: calc(25% - var(--player-circle-size) / 2);
  right: calc(-1.2 * (var(--player-circle-size) / 2));
}

// ----mobile

.left-top-end {
  top: calc(50% - (var(--player-circle-size) / 2));
  left: calc(-1 * var(--player-circle-size) / 2);
}
.right-top-end {
  top: calc(50% - (var(--player-circle-size) / 2));
  right: calc(-1 * var(--player-circle-size) / 2);
}

.left-top-start {
  top: calc(15% - (var(--player-circle-size) / 2));
  left: 0;
}
.right-top-start {
  top: calc(15% - (var(--player-circle-size) / 2));
  right: 0;
}

.left-middle-top {
  top: calc(30% - var(--player-circle-size) / 2);
  left: calc(-1 * var(--player-circle-size) / 2);
}
.left-middle-bottom {
  bottom: calc(30% - var(--player-circle-size) / 2);
  left: calc(-1 * var(--player-circle-size) / 2);
}
.right-middle-top {
  top: calc(30% - (var(--player-circle-size) / 2));
  right: calc(-1 * var(--player-circle-size) / 2);
}
.right-middle-bottom {
  bottom: calc(30% - var(--player-circle-size) / 2);
  right: calc(-1 * var(--player-circle-size) / 2);
}

.left-bottom-end {
  bottom: calc(15% - (var(--player-circle-size) / 2));
  left: 0;
}
.right-bottom-end {
  bottom: calc(15% - (var(--player-circle-size) / 2));
  right: 0;
}

// mobile 9players
// .mobile-top-left-end-middle {
//   top: calc(-1 * (var(--player-circle-size) / 2));
//   left: calc(25% - var(--player-circle-size) / 2);
// }
.left-bottom-end-middle {
  top: calc(94% - (var(--player-circle-size) / 2));
  left: calc(20% - var(--player-circle-size) / 2);
}
.left-top-end-middle {
  top: calc(63% - (var(--player-circle-size) / 2));
  left: calc(-1 * var(--player-circle-size) / 2);
}
.left-top-start-middle {
  top: calc(36% - (var(--player-circle-size) / 2));
  left: calc(-1 * var(--player-circle-size) / 2);
}
.right-top-end-middle {
  top: calc(63% - (var(--player-circle-size) / 2));
  right: calc(-1 * var(--player-circle-size) / 2);
}
.right-top-start-middle {
  top: calc(36% - (var(--player-circle-size) / 2));
  right: calc(-1 * var(--player-circle-size) / 2);
}
</style>
